import getNullEmptyValue from 'common/util/getNullEmptyValue';

export default function setNullEmptyValues(values) {
  if (!values) {
    return values;
  }
  const sanitizedValues = {};
  for (const key of Object.keys(values)) {
    sanitizedValues[key] = getNullEmptyValue(values[key]);
  }
  return sanitizedValues;
}
